'use strict';

var ChartDashboardRankingsDirective = function ChartDashboardRankingsDirective() {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-rankings.html'),
    controller: 'ChartDashboardRankingsController',
    scope: {
      mode: '@',
      screen: '@',
      screenState: '=',
      isCollapsible: '='
    },
    link: function link($scope, element) {
      element = element.children('.rm-chart-dashboard-rankings');
      $scope.setChartVisibility = function (show) {
        $scope.isChartVisible = show;
        element.toggleClass('collapsed', !show);
      };
      $scope.$watch('screenState.aggregationMode', function () {
        if ($scope.isChartVisible) {
          $scope.reloadChart();
        }
      });
      $scope.$watch('screenState', function () {
        if ($scope.isLoadFactorMetric() && $scope.ranking.name !== 'MARKET') {
          $scope.ranking.name = 'MARKET';
        }
        if ($scope.isChartVisible) {
          $scope.reloadChart();
        }
      }, true);
      $scope.$on('DASHBOARD_SCREEN-market-dashboard:metricChanged', function () {
        if ($scope.isChartVisible) {
          $scope.reloadChart();
        }
      });
      $scope.$on('brush-filter:filterApplied', function (event, brushFilter) {
        if (brushFilter.filterType !== 'markets-and-poses') {
          $scope.reloadChart();
        }
      });
      $scope.$on('search-criteria:searchChangeEvent', function () {
        var adjustPanelVisibility = true;
        $scope.resetChartData();
        $scope.reloadChart(adjustPanelVisibility);
      });
      $scope.toggleChartVisibility = function () {
        $scope.setChartVisibility(!$scope.isChartVisible);
      };
      $scope.$on($scope.screen + '-' + $scope.mode + ':dimensionChanged', function () {
        if ($scope.isChartVisible) {
          $scope.reloadChart();
        } else {
          $scope.$broadcast('dashboard:ranking:brush-filter');
        }
      });
    }
  };
};
ChartDashboardRankingsDirective.$inject = [];
module.exports = ChartDashboardRankingsDirective;